import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Dec 20 2018
 * @author LZe
 */
import * as React from 'react';
import VSelect from 'react-virtualized-select';
import { showIf } from '../../../shared/rendering/showIf';
import withValidation from '../../inputs/withValidation';
import Icon, { IconColor } from '../../media/Icon';
import StyledLabel from '../../typography/Label';
import Select from './Select';
import SelectStyled from './styled/SelectStyled';
import SelectWrapper from './styled/SelectWrapper';
/**
 * [See DOCS for react-virtualized-select](https://github.com/bvaughn/react-virtualized-select)
 */

var SelectIcon =
/*#__PURE__*/
function (_Select) {
  _inherits(SelectIcon, _Select);

  function SelectIcon() {
    _classCallCheck(this, SelectIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectIcon).apply(this, arguments));
  }

  _createClass(SelectIcon, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.label && React.createElement(StyledLabel, null, this.props.label), React.createElement(SelectWrapper, {
        tiny: this.props.tiny,
        withIconIn: this.props.withIconIn,
        className: "input-wrapper"
      }, React.createElement(SelectStyled, {
        tiny: this.props.tiny,
        multi: this.props.multi,
        className: "Select-icon"
      }, React.createElement(VSelect, Object.assign({}, this.props, {
        placeholder: this.getPlaceholder(),
        onChange: this.onChange,
        classNamePrefix: "react-select",
        autosize: false,
        searchable: false,
        clearable: false
      })), showIf(this.props.selectIconType, React.createElement("div", {
        className: "input-icon"
      }, React.createElement(Icon, {
        iconType: this.props.selectIconType,
        iconHeight: 20,
        iconColor: IconColor.Text
      }))))));
    }
  }]);

  return SelectIcon;
}(Select);

export default SelectIcon;
export var SelectIconValidated = withValidation(SelectIcon);